var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyAccountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15046",
    fill: "none",
    d: "M0 0h16v16H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconly/Bold/Add User"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Add User",
    d: "M2.952 12.206c0-1.74 2.325-2.175 5.048-2.175s5.048.45 5.048 2.19S10.723 14.396 8 14.396s-5.048-.453-5.048-2.19zM4.66 4.989a3.34 3.34 0 116.68 0 3.34 3.34 0 11-6.68 0z"
  }))));
}
export default SvgMyAccountIcon;